module.exports = __webpack_public_path__ + "static/media/delete.85eb9ca2.svg";